import React from 'react';
import { DashboardLayout } from '../../layouts/DashboardLayout';
import { Crown, Check } from 'lucide-react';

const PlanComplementos = () => {
  const features = [
    'Punto de Venta (POS)',
    'Marketplace en linea',
    'Gestion de inventario',
    'Reportes basicos',
    'Hasta 2 sucursales',
    'Soporte por tickets',
  ];

  return (
    <DashboardLayout>
      <div className="max-w-2xl mx-auto py-12">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full mb-4">
            <Crown className="w-8 h-8 text-amber-600" />
          </div>
          <h1 className="text-3xl font-bold text-slate-900">Plan y Complementos</h1>
          <p className="text-slate-500 mt-2">
            Proximamente podras gestionar tu plan y contratar complementos para tu negocio
          </p>
        </div>

        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="p-6 border-b border-slate-200 bg-slate-50">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-lg font-semibold text-slate-900">Plan Basico</h2>
                <p className="text-sm text-slate-500">Tu plan actual</p>
              </div>
              <span className="px-3 py-1 bg-teal-100 text-teal-700 text-sm font-medium rounded-full">
                Activo
              </span>
            </div>
          </div>
          <div className="p-6">
            <ul className="space-y-3">
              {features.map((feature, idx) => (
                <li key={idx} className="flex items-center gap-3 text-slate-700">
                  <div className="flex-shrink-0 w-5 h-5 bg-teal-100 rounded-full flex items-center justify-center">
                    <Check className="w-3 h-3 text-teal-600" />
                  </div>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          <div className="p-6 border-t border-slate-200 bg-slate-50 text-center">
            <p className="text-sm text-slate-500">
              Los planes premium y complementos estaran disponibles proximamente.
            </p>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PlanComplementos;
